let vueRegisterForm = new Vue({
    el: "#register-form",

    data: function () {
        return {
            show: false,
            password: '',
            password_confirmation: '',
            email: '',
            email_confirmation: '',
            hasEmailError: true,
            hasPasswordError: true,
            errorMessage: '',
            errorMessagePassword: '',
            hasCaptchaError: false,
            hasCheckedTerms: false,
        };
    },

    computed: {
        shoudlEnableBtnRegister() {
            return !this.hasPasswordError && !this.hasEmailError && !this.hasCaptchaError && this.hasCheckedTerms;
        },
    },

    methods: {
        close: function () {
            this.show = false;
        },

        open: function () {
            this.show = true;
        },

        showPassword(inputId, eyeId) {
            $(`#${inputId}`).attr('type') == 'password'
                ? $(`#${inputId}`).attr('type', 'text')
                : $(`#${inputId}`).attr('type', 'password');

            $(`#${eyeId}`).toggleClass('fa-eye-slash');
        },

        validateEmail() {
            $.get(`validate-email?email=${this.email}&email_confirmation=${this.email_confirmation}`)
                .success(() => {
                    this.errorMessage = '';
                    this.hasEmailError = false;
                })
                .fail(data => {
                    _.get(data, 'responseJSON.errors.email').forEach(element => {
                        this.errorMessage = element;
                    });
                    this.hasEmailError = true;
                });
        },
        validateCaptcha(val) {
            this.hasCaptchaError = val;
        },
        validatePassword() {
            $.post('validate-password', {
                password: this.password,
                password_confirmation: this.password_confirmation
            })
            .success(() => {
                this.errorMessagePassword = '';
                this.hasPasswordError = false;
            })
            .fail(data => {
                _.get(data, 'responseJSON.errors.password').forEach(element => {
                    this.errorMessagePassword = element;
                });
                this.hasPasswordError = true;
            });
        }
    },
});
